import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-key-large",
  templateUrl: "./med-icon-key-large.component.html",
})
export class MedIconKeyLargeComponent extends SvgMixinLargeComponent { }
